Object.defineProperty(exports, '__esModule', { value: true });

var exhaustiveCheck = function (value) { return value; };

exports.exhaustiveCheck = exhaustiveCheck;
